import request from '@/apis/request'
const resource = 'st' 

export default {
  getWinNumber: (params = {}) => {
    return request.get(`${resource}/win-number`,{ params })
  },

  getAllList: (params = {}) => {
    return request.get(`${resource}`,{ params })
  },

  getListById: (uid) => { 
    return request.get(`${resource}/${uid}`)
  },

  cancel: (uid) => { 
    return request.delete(`${resource}/${uid}`)
  },

  getSummary: (params = {}) => { 
    return request.get(`${resource}/summaries`, {params})
  }, 

}